import { AuthConfig } from 'angular-oauth2-oidc';
export const FsxB2CDocumentDiscoveryURL = 'https://fsagencyilsosuat.b2clogin.com/fsagencyilsosuat.onmicrosoft.com/B2C_1A_EMAIL_SIGNIN/v2.0/.well-known/openid-configuration';
const FsxB2CClientId = '8bd7b84e-271d-4346-aa6d-915d8ab655d9';
const FsxB2CScopes = 'openid profile email offline_access https://fsagencyilsosuat.onmicrosoft.com/8bd7b84e-271d-4346-aa6d-915d8ab655d9/access_as_user';
const FsxB2CIssuer = 'https://fsagencyilsosuat.b2clogin.com/9b971cb4-329c-4e8b-b5e5-758416886e5e/v2.0/'
const FsxB2CLoginUrl = 'https://fsagencyilsosuat.b2clogin.com/fsagencyilsosuat.onmicrosoft.com/B2C_1A_EMAIL_SIGNIN/oauth2/v2.0/authorize';
const FsxB2CLogoutUrl = 'https://fsagencyilsosuat.b2clogin.com/fsagencyilsosuat.onmicrosoft.com/signout/B2C_1A_EMAIL_SIGNIN'


export const authConfig: AuthConfig = {
  // ToDo: Need to store these magic strings in environment variables.
  issuer: FsxB2CIssuer,
  loginUrl: FsxB2CLoginUrl,
  logoutUrl: FsxB2CLogoutUrl,
  // ToDo: I believe we need to register all possible returnUri's in the Azure AD B2C App Registration
  redirectUri: window.location.origin + '/index.html',
  clientId: FsxB2CClientId,
  responseType: 'code',
  strictDiscoveryDocumentValidation: false,
  scope: FsxB2CScopes,
  showDebugInformation: false,
  skipIssuerCheck: false,
  // timeoutFactor: .01
}
